export default [
    {
        name: '单据列表',
        path: '/index/receiptsList'
    },
    {
        name: '模板下载',
        path: '/index/templateDownload'
    },
    {
        name: '修改密码',
        path: '/index/modifyPass'
    },
    // {
    //     name: '销售汇总',
    //     path: '/index/sales-statistics'
    // },
    {
        name: '物资销售汇总',
        path: '/index/materialsSales'
    },
    {
        name: '申报新物资',
        path: '/index/declare'
    },
    {
        name: '草稿箱',
        path: '/index/draft'
    }
];



// WEBPACK FOOTER //
// ./src/menus/menus.js